// src/contexts/ThemeContext.js
import React, { createContext, useState, useMemo } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";

export const ThemeContext = createContext();

const ThemeContextProvider = ({ children }) => {
    // Récupérer le thème stocké ou mettre "light" par défaut
    const storedTheme = localStorage.getItem("theme") || "light";
    const [mode, setMode] = useState(storedTheme);

    // Basculer le thème et le stocker
    const toggleTheme = () => {
        setMode((prevMode) => {
            const newMode = prevMode === "light" ? "dark" : "light";
            localStorage.setItem("theme", newMode);
            return newMode;
        });
    };

    // Créer un thème MUI basé sur l'état actuel
    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode: mode,
                    background: {
                        default: mode === "dark" ? "#202124" : "#ffffff",
                        paper: mode === "dark" ? "#171717" : "#f5f5f5",
                    },
                    text: {
                        primary: mode === "dark" ? "#ffffff" : "#202124",
                    },
                },
            }),
        [mode]
    );

    return (
        <ThemeContext.Provider value={{ mode, toggleTheme }}>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </ThemeContext.Provider>
    );
};

export default ThemeContextProvider;
